"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationOptOut = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
/**
 * Tracks opt-outs per contact per channel.
 * Before every send, NotificationsService checks this table.
 * channel = 'all'  →  opted out of ALL channels for this contact.
 * channel = 'sms'  →  only opted out of SMS, etc.
 */
let CommunicationOptOut = class CommunicationOptOut {
};
exports.CommunicationOptOut = CommunicationOptOut;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], CommunicationOptOut.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({ length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], CommunicationOptOut.prototype, "phone", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({ length: 150, nullable: true }),
    tslib_1.__metadata("design:type", String)
], CommunicationOptOut.prototype, "email", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 20, default: 'all' }),
    tslib_1.__metadata("design:type", String)
], CommunicationOptOut.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], CommunicationOptOut.prototype, "reason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CommunicationOptOut.prototype, "optedOutAt", void 0);
exports.CommunicationOptOut = CommunicationOptOut = tslib_1.__decorate([
    (0, typeorm_1.Entity)('communication_opt_outs')
], CommunicationOptOut);
